
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...spaInsLifeQuotesEN]",
      function () {
        return require("private-next-pages/[...spaInsLifeQuotesEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...spaInsLifeQuotesEN]"])
      });
    }
  